export const PROPOSAL_DIALOG_SHOW = 'PROPOSAL_DIALOG_SHOW';
export const PROPOSAL_DIALOG_HIDE = 'PROPOSAL_DIALOG_HIDE';

export const PROPOSALS_FETCH_IN_PROGRESS = 'PROPOSALS_FETCH_IN_PROGRESS';
export const PROPOSALS_FETCH_SUCCESS = 'PROPOSALS_FETCH_SUCCESS';
export const PROPOSALS_FETCH_ERROR = 'PROPOSALS_FETCH_ERROR';

export const PROPOSAL_VOTES_FETCH_IN_PROGRESS = 'PROPOSAL_VOTES_FETCH_IN_PROGRESS';
export const PROPOSAL_VOTES_FETCH_SUCCESS = 'PROPOSAL_VOTES_FETCH_SUCCESS';
export const PROPOSAL_VOTES_FETCH_ERROR = 'PROPOSAL_VOTES_FETCH_ERROR';

export const VOTE_DETAILS_FETCH_IN_PROGRESS = 'VOTE_DETAILS_FETCH_IN_PROGRESS';
export const VOTE_DETAILS_FETCH_SUCCESS = 'VOTE_DETAILS_FETCH_SUCCESS';
export const VOTE_DETAILS_FETCH_ERROR = 'VOTE_DETAILS_FETCH_ERROR';

export const PROPOSAL_TALLY_FETCH_IN_PROGRESS = 'PROPOSAL_TALLY_FETCH_IN_PROGRESS';
export const PROPOSAL_TALLY_FETCH_SUCCESS = 'PROPOSAL_TALLY_FETCH_SUCCESS';
export const PROPOSAL_TALLY_FETCH_ERROR = 'PROPOSAL_TALLY_FETCH_ERROR';

export const PROPOSAL_DETAILS_FETCH_IN_PROGRESS = 'PROPOSAL_DETAILS_FETCH_IN_PROGRESS';
export const PROPOSAL_DETAILS_FETCH_SUCCESS = 'PROPOSAL_DETAILS_FETCH_SUCCESS';
export const PROPOSAL_DETAILS_FETCH_ERROR = 'PROPOSAL_DETAILS_FETCH_ERROR';
